import styled from 'styled-components'

import theme from '../../utils/theme'
import TrustPilot from '../TrustPilot'

const StyledPrivacy = styled.div`
  color: ${`var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`};
  display: flex;
  flex-direction: column;
  font-size: ${theme.typography.fontSizeSm};
  margin: 1em auto 0;
  max-width: 340px;
  text-align: center;

  [data-theme="dark"] & {
    color: ${theme.colors.darkModeGrey};
  }

  p {
    margin: 0.25em 0;
  }
`

const StyledList = styled.div`
  a,
  a:visited {
    border-right: 1px solid ${theme.colors.border};
    color: ${theme.palette.primary.main};
    font-weight: ${theme.typography.fontWeightBolder};
    margin: 0.5rem 0 0;
    line-height: 1;
    padding: 0 0.5rem 2px;
    text-decoration: none;

    &:hover {
      color: ${theme.palette.primary.dark};
    }

    &:last-child {
      border: none;
    }
  }
`

const GameDayPrivacy = ({ showLogout, logoutPath, showTrustPilot }) => {
  return (
    <StyledPrivacy>
      <StyledList>
        {showLogout && logoutPath && <a href={logoutPath}>Log Out</a>}
        <a href="https://mygameday.app/privacy-policy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </StyledList>
      <p> © Copyright GameDay. All rights reserved. </p>
      {showTrustPilot && <TrustPilot />}
    </StyledPrivacy>
  )
}

export default GameDayPrivacy
